<template>
    <div>
        <div class="tit-head">主观题</div>
        <div class="stem" v-html="info.title"></div>
        <p contenteditable="true" ref="commentTextRef" id="content" class='text' @input="changeText"></p>
    </div>
</template>
<script>
export default {
    props:{
        info:{
            type:Object,
            default:null
        },
    },
    data(){
        return{
            subjectAnswer: ''
        }
    },
    mounted(){},
    methods:{
        changeText(){
            this.subjectAnswer = this.$refs.commentTextRef.innerHTML
            this.$emit('childQuestionFn', this.subjectAnswer);
        },
    }
}
</script>
<style lang="less" scoped>
.stem{
    /deep/ img{
        max-width: 100%;
    }
    /deep/ p{
        font-size: 16px;
        font-weight: 700;
        color: #555;
    }
}
.tit-head{
    display: inline-flex;
    flex-wrap: wrap;
    width: 100%;
    div:first-child{
        display: inline-flex;
        align-items: center;
        color: #555;
        height: 26px;
        line-height: 26px;
        background-color: #18A0FB;
        color: #fff;
        padding: 0 10px;
        border-radius: 13px 13px 0 13px;
        margin-right: 15px;
        min-width: 62px;
    }
    .stem{
        width: 80%;
        /deep/ img{
            max-width: 100%;
        }
        /deep/ p{
            font-size: 16px;
            font-weight: 700;
            color: #555;
        }
    }
}
.text{
    outline: none;
    padding: 15px;
    width: 100%;
    min-height: 128px;
    border: 1px solid rgba(0, 0, 0, 0.0588235294117647);
    border-radius: 6px;
    background: #fafafa;
    margin-top: 20px;
}
</style>


// WEBPACK FOOTER //
// src/views/practise/components/questionSubject.vue